module.exports = __webpack_public_path__ + "img/baner-volkswagen-dostawcze.a474a1be.png";